import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import { Spinner } from 'react-bootstrap';

import { white, squidInk, greyStroke, shadowLight, shadowMedium } from 'lib/css/colors';

function HarvestStatWidget({ label, count, subtext, gradient, loading = false }) {
  return (
    <div className={css(styles.container)}>
      <div className={css(styles.accentBar)} style={{ background: gradient }} />
      <div className={css(styles.content)}>
        <div className={css(styles.label)}>{label}</div>
        {loading ? (
          <div className={css(styles.loadingContainer)}>
            <Spinner animation="border" role="status" size="sm" />
          </div>
        ) : (
          <>
            <div className={css(styles.count)}>{count?.toLocaleString() || 0}</div>
            {subtext && <div className={css(styles.subtext)}>{subtext}</div>}
          </>
        )}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: white,
    borderRadius: 12,
    border: `1px solid ${greyStroke}`,
    boxShadow: `0 1px 3px ${shadowLight}`,
    overflow: 'hidden',
    transition: 'all 0.2s ease',
    ':hover': {
      boxShadow: `0 4px 12px ${shadowMedium}`,
      transform: 'translateY(-2px)',
    },
  },
  accentBar: {
    height: 4,
    width: '100%',
  },
  content: {
    padding: '16px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  label: {
    fontSize: 13,
    fontWeight: 600,
    color: squidInk,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    opacity: 0.7,
  },
  count: {
    fontSize: 32,
    fontWeight: 700,
    color: squidInk,
    lineHeight: 1,
  },
  subtext: {
    fontSize: 12,
    color: squidInk,
    opacity: 0.6,
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    height: 40,
  },
});

HarvestStatWidget.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number,
  subtext: PropTypes.string,
  gradient: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

export default HarvestStatWidget;
